import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionSection } from './components/SolutionSection';
import { ValueStackSection } from './components/ValueStackSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AdvancedEditionSection } from './components/AdvancedEditionSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { GuaranteeFooter } from './components/GuaranteeFooter';
export function App() {
  return <div className="min-h-screen bg-brand-white font-sans text-brand-purple selection:bg-brand-gold/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <AgitationSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ValueStackSection data-id="element-5" />
      <ForWhoSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <AdvancedEditionSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalCTASection data-id="element-10" />
      <GuaranteeFooter data-id="element-11" />
    </div>;
}